// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".saveModal-module___modal_warning__content___AILSi {\n  margin: 40px 0 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/js/pages/playbookPages/playbookSegmentationPage/saveModal/saveModal.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","sourcesContent":["._modal_warning__content {\n  margin: 40px 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"_modal_warning__content": "saveModal-module___modal_warning__content___AILSi"
};
export default ___CSS_LOADER_EXPORT___;
